<template>
    <div class="h-12 bg-white flex justify-between items-center">
        <div class="pl-4">
            <div v-if="$route.name === 'missionsDetail'" class="cursor-pointer"
                 @click="$router.push({ name : 'missions' })">
                <BackSVG class="w-3 -mt-1 inline"></BackSVG>
                <div class="ml-2 inline">{{ $t('text.back') }}</div>
            </div>
            <div v-else-if="$route.name === 'missions'" class="cursor-pointer"
                 @click="$router.push({ name : 'app' })">
                <BackSVG class="w-3 -mt-1 inline"></BackSVG>
                <div class="ml-2 inline">{{ $t('text.back') }}</div>
            </div>
            <img v-else class="ml-2 cursor-pointer"
                 :src="getLogoUrl"
                 @click="$router.push({ name: 'app' })">
        </div>

        <div v-if="loggedIn" class="cursor-pointer" @click="$router.push({ name: 'applications'})">
            <svg class="w-5 inline" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M15 21c0 1.598-1.392 3-2.971 3s-3.029-1.402-3.029-3h6zm.137-17.055c-.644-.374-1.042-1.07-1.041-1.82v-.003c.001-1.172-.938-2.122-2.096-2.122s-2.097.95-2.097 2.122v.003c.001.751-.396 1.446-1.041 1.82-4.668 2.709-1.985 11.715-6.862 13.306v1.749h20v-1.749c-4.877-1.591-2.193-10.598-6.863-13.306zm-3.137-2.945c.552 0 1 .449 1 1 0 .552-.448 1-1 1s-1-.448-1-1c0-.551.448-1 1-1zm-6.451 16c1.189-1.667 1.605-3.891 1.964-5.815.447-2.39.869-4.648 2.354-5.509 1.38-.801 2.956-.76 4.267 0 1.485.861 1.907 3.119 2.354 5.509.359 1.924.775 4.148 1.964 5.815h-12.903z"/></svg>
            <div class="inline text-sm font-bold bg-blue-600 text-white rounded rounded-full px-1">
                <span v-if="isAcceptedApplication">1</span>
                <span v-else>0</span>
            </div>
        </div>

        <span class="cursor-pointer mr-4" @click="setMenu">
            {{ $t('text.menu') }}
            <svg class="fill-current h-4 w-4 inline" version="1.2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="20" height="24"><g><path xmlns:default="http://www.w3.org/2000/svg" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" style="fill: rgb(18, 18, 18);" vector-effect="non-scaling-stroke"/></g></svg>
        </span>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import BackSVG from "@/components/shared/svgs/BackSVG";

    export default {
        name: "Header",
        components: {BackSVG},
        data() {
          return {

          }
        },
        computed: {
            ...mapState('app', {
                'showMainMenu': 'showMainMenu'
            }),
            ...mapState('auth', {
                'isAcceptedApplication': 'isAcceptedApplication'
            }),
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn',
                'user': 'user'
            }),
            ...mapGetters('dlGroupConfig', [
                'getLogoUrl',
            ]),
        },
        created() {
        },
        methods: {
            setMenu() {
                if (this.showMainMenu) {
                    this.$store.commit('app/hideMainMenu');
                } else {
                    this.$store.commit('app/showMainMenu');
                }
            }
        }
    }
</script>

<style scoped>

</style>